<template>
  <div style="margin-top: 10px">

        <el-form-item>
          <span>二维码标签 ：</span>
          <el-button @click="printPreview" :loading="loading">预览</el-button>
          <el-button @click="print" :loading="loading">打印</el-button>
          <KfMessage ref="commitMessage"></KfMessage>
        </el-form-item>
        <el-form-item>
          <div id="divPrint" v-for="item in this.printImages" :key="item.imageBase64">
            <img class="preview-img" :src="item.imageBase64" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'"
                 v-if="item.imageBase64.length > 0">
          </div>
        </el-form-item>


  </div>
</template>

<script>

export default {
  name: "EqSawBladeZhiZaoPrint",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      sawBladeList:[],
      imageHeight: 300,
      imageWidth: 480,
      printDto: {},
      printImages:[],
      printDtoList:[]
    }
  },
  computed: {

  },
  methods:{


    async printPreview() {
      this.loading = true;
      this.printImages = []

      this.$http('eqSawBladeZhiZaoService.getSawBladeLabel',this.parentData).then(data => {
        this.loading = false;
        this.printDtoList = data

        for (let i = 0; i < this.printDtoList.length; i++) {
          let printDto = JSON.parse(JSON.stringify(this.printDtoList[i]))
          if (printDto.image_base64.length > 0) {
            printDto.image_base64 = "data:image/jpeg;base64," + printDto.image_base64;
          }
          this.printImages.push(printDto)
        }
      }, errMsg => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${errMsg}`);
      })
    },

    async print() {
      await this.printPreview();
      this.loading = false;
      // this.printDiv()
      // 调用本地打印服务器
      // var printParams = {printer_name: this.printDto.printerName, zpl: this.printDto.zpl};
      for (let i = 0; i < this.printDtoList.length; i++) {
        console.log(this.printDtoList[i])
        this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDtoList[i]).then(response => {
          this.loading = false;
          let res = response.data
          console.log(res)
        }, error => {
          this.loading = false;
          console.log(`提交打印失败，${error.message}`)
          this.$message.error('连接打印机失败，请检查打印机状态。');
        })
      }
    },

    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    },



  },
  created() {
  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 650px;
  margin-left: 80px
}
.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
.row {
  margin-left: 80px;
  width: 650px;
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
</style>